import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const ApiTags = Object.freeze({
  JobPostings: 'JobPostings',
  LandingPages: 'LandingPages'
})

export const apiSlice = createApi({
  reducerPath: 'apiReducer',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/' }),
  tagTypes: Object.keys(ApiTags),
  endpoints: () => ({})
})
